module.exports = __webpack_public_path__ + "img/GD Logo V2.c5fc262c.png";